if (!customElements.get('review-carousel')) {
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.review-carousel__slide'));
      if (this.slides.length === 0) return;

      this.currentIndex = 0;

      const prevBtn = this.querySelector('.review-carousel__btn--prev');
      const nextBtn = this.querySelector('.review-carousel__btn--next');

      if (prevBtn) prevBtn.addEventListener('click', () => this.prev());
      if (nextBtn) nextBtn.addEventListener('click', () => this.next());

      // Touch / swipe support
      this._touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        this._touchStartX = e.touches[0].clientX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].clientX - this._touchStartX;
        if (Math.abs(delta) > 50) {
          delta < 0 ? this.next() : this.prev();
        }
      }, { passive: true });
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides[this.currentIndex].classList.add('is-active');
    }

    prev() { this.goTo(this.currentIndex - 1); }
    next() { this.goTo(this.currentIndex + 1); }
  }

  customElements.define('review-carousel', ReviewCarousel);
}
